import styled from "styled-components";
import BundlePrice from "../BundlePrice";
import BundleProduct from "../BundleProduct/index";
import Global from "../Helper/index";
import { BundleProps } from "./types";
import { GradientDirection } from "../Helper/types";

const createGradientOrSolid = ({
  colorOne,
  colorTwo,
  gradientDirection,
}: {
  colorOne: string;
  colorTwo?: string;
  gradientDirection?: GradientDirection;
}) => {
  if (colorOne && !colorTwo) {
    return colorOne;
  }
  return `linear-gradient(${gradientDirection}, ${colorOne}, ${colorTwo})`;
};

const StyledBundle = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: ${(props: any) => props.width}px;
  height: ${(props: any) => props.height}px;
  position: relative;
  border-radius: 20px;
  padding: ${(props: any) => props.borderSize}px;
  background: ${(props: any) => createGradientOrSolid(props.bundleBorderColor)};
` as any;

const StyledContainer = styled.div`
  height: calc(100% - 20px);
  width: 100%;
  border-radius: 15px;
  background: ${(props: any) =>
    props.backgroundSrc
      ? `url("${props.backgroundSrc}")`
      : "linear-gradient(180deg, #1f3673 0%, #0b1031 100%)"};
  background-position: 50% 50%;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
` as any;

const StyledProducts = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1em;
`;

const StyledLowerPart = styled.div`
  width: 100%;
  height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  position: absolute;
  bottom: 0;
  div {
    display: inline-block;
    padding: 0 1em;
    text-shadow: 1px 1px 0 black, -1px -1px 0 black, 1px -1px 0px black,
      -1px 1px 0 black;
    span {
      margin: 0;
      color: #ffffff;
      font-size: 1em;
      letter-spacing: 0.02em;
      font-weight: 400;
      line-height: 1.43;
    }
  }
`;

function Bundle({
  width = 420,
  height = 215,
  backgroundColor = "blue",
  borderSize = 4,
  backgroundSrc = "https://animal-kingdom-media.s3.amazonaws.com/BG-3.webp?a=a",
  price = 100,
  maxAvailable = 10,
  available = maxAvailable,
  productList = [
    {
      color: "#ffabff",
      img: "https://animal-kingdom-media.s3.amazonaws.com/asset-2.png?a=a",
      amount: 100,
    },
    {
      color: "#ffe060",
      img: "https://animal-kingdom-media.s3.amazonaws.com/asset-3.png?a=a",
      amount: 50000,
    },
    {
      color: "#60d9ff",
      img: "https://animal-kingdom-media.s3.amazonaws.com/asset.png?a=a",
      amount: 80,
    },
  ],
  bundleBorderColor,
  bundleButtonColor,
  bundleButtonTextColor,
}: BundleProps) {
  return (
    <Global>
      <StyledBundle
        width={width}
        height={height}
        borderSize={borderSize}
        bundleBorderColor={bundleBorderColor}
      >
        <StyledContainer backgroundSrc={backgroundSrc}>
          <StyledProducts>
            {productList.map((product, i) => {
              return (
                <BundleProduct
                  color={product.color}
                  img={product.img}
                  amount={product.amount}
                  key={i}
                />
              );
            })}
          </StyledProducts>
          <BundlePrice
            price={price}
            buttonColor={bundleButtonColor}
            buttonTextColor={bundleButtonTextColor}
          />
          <StyledLowerPart>
            {!!maxAvailable && (
              <div>
                <span>
                  Available {available}/{maxAvailable}
                </span>
              </div>
            )}
          </StyledLowerPart>
        </StyledContainer>
      </StyledBundle>
    </Global>
  );
}

export default Bundle;
